<template>
  <div>
    <div id="header" class="main-app-main-header">
      <div class="logo-section d-flex align-items-center">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="logo-icon text-center ">
                <router-link to="/">
                  <img src="/assets/img/f7_jp_logo.png" alt="">
                </router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="terms-and-conditions">
      <h1>Terms and Conditions</h1>
      <p>Welcome to our website. If you continue to browse and use this website, you are agreeing to comply with and be
        bound by the following terms and conditions of use.</p>
      <h2>1. Introduction</h2>
      <p>These terms and conditions govern your use of this website; by using this website, you accept these terms and
        conditions in full.</p>
      <!-- Add more sections and subsections as needed -->
    </div>


  </div>
</template>


<script>
import {mapActions} from "vuex";

export default {
  name: "dashboard-default",
  data() {
    return {};
  },
  components: {},
  mounted() {
    this.setGames()
  },
  methods: {
    ...mapActions(["getGames", "placeBet",]),
    //

  }
};
</script>

<style scoped> /* Default styles */
h4, h1, h6, img {
  margin: 0;
  padding: 0;
}

/* Styles for screens smaller than 600px wide */
@media screen and (max-width: 600px) {
  h4 {
    font-size: 14px; /* Adjust as needed */
  }

  h1 {
    font-size: 18px; /* Adjust as needed */
  }

  h6 {
    font-size: 10px; /* Adjust as needed */
  }

  /* Default styles for all images */
  .carousel-item img {
    max-width: 100%; /* Ensures image fits container width */
  }

  /* Styles for the first image */
  .img-adjust-220x65 {
    @media screen and (max-width: 600px) {
      max-width: 200px; /* Adjust max-width as needed */
      height: 65px; /* Changed height to 65px */
    }
  }
}

/* Add any necessary CSS styles here */
.terms-and-conditions {
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
}
</style>